module.exports = __webpack_public_path__ + "media/src/images/balloons/HomeBanner-green-89a65230d606b07d000ec4a52d4e291b.jpg";